import { render } from "./sendmoney.vue?vue&type=template&id=2ec7080a&scoped=true"
import script from "./sendmoney.vue?vue&type=script&lang=js"
export * from "./sendmoney.vue?vue&type=script&lang=js"

import "./sendmoney.vue?vue&type=style&index=0&id=2ec7080a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec7080a"]])

export default __exports__